import React from 'react';

import './earn-history-items.scss';

const TITLE_COLOR = '#1e1e1e';
const SUB_TEXT_COLOR = '#717171';

const EarnHistoryItems = ({ item }) => {
  return (
    <div className="history-items--itemsContainer">
      <div className="history-items--itemsBox">
        {item?.imageUrl && (
          <img className="history-items--iconImage" src={item?.imageUrl} />
        )}
        {item?.alerticon && (
          <img className="history-items--alertImage" src={item?.alerticon} />
        )}
      </div>
      <div className="history-items--boxContent">
        <div className="history-items--infocontainer">
          {item?.title && (
            <div className="history-items--textContainer">
              <span
                className="history-items--titleText"
                style={{
                  color: item?.titleColour ? item?.titleColour : TITLE_COLOR,
                }}
              >
                {item?.title}
              </span>
            </div>
          )}
          {item?.date && (
            <div className="history-items--dateContainer">
              <div
                className="history-items--subtitleText"
                style={{
                  color: item?.dateColor ? item?.dateColor : SUB_TEXT_COLOR,
                }}
              >
                {item?.date}
              </div>
            </div>
          )}
        </div>
        {item?.orderText && (
          <div
            className="history-items--subtitleText history-items--space"
            style={{
              color: item?.orderTextColour
                ? item?.orderTextColour
                : SUB_TEXT_COLOR,
            }}
          >
            {item?.orderText}
          </div>
        )}
        {item?.subtitle && (
          <div
            className="history-items--subtitleText"
            style={{
              color: item?.subtitleColour
                ? item?.subtitleColour
                : SUB_TEXT_COLOR,
            }}
          >
            {item?.subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default EarnHistoryItems;
